import { render, staticRenderFns } from "./routeIndex.vue?vue&type=template&id=1ca43b1e&scoped=true&"
import script from "./routeIndex.vue?vue&type=script&lang=js&"
export * from "./routeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca43b1e",
  null
  
)

export default component.exports